import React from "react";
import { CreaSolicitudYupana } from "../components";
import Layout from "../components/Layout";

const NuevaSolicitudYupana = () => {
    return (
        <Layout>
            <div className="py-6 min-h-screen bg-slate-50/50">

                {/* Page Header */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="flex items-center gap-3">
                        <div className="w-1.5 h-10 bg-gradient-to-b from-blue-600 to-blue-400 rounded-full flex-shrink-0" />
                        <div>
                            <h1 className="text-2xl font-bold text-slate-800 tracking-tight leading-tight">
                                Nueva Solicitud de Crédito
                            </h1>
                            <p className="text-sm text-slate-500 mt-0.5">
                                Complete el formulario para procesar la solicitud del cliente
                            </p>
                        </div>
                    </div>
                    <div className="ml-auto hidden sm:flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold px-3 py-1.5 rounded-full">
                        <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                        </svg>
                        Proceso Seguro
                    </div>
                </div>

                {/* Main Form Card */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                    {/* Top accent bar */}
                    <div className="h-1.5 bg-gradient-to-r from-blue-600 via-violet-500 to-amber-500" />

                    <div className="p-6 lg:p-10">
                        <CreaSolicitudYupana />
                    </div>

                    {/* Footer */}
                    <div className="bg-slate-50 border-t border-slate-100 px-8 py-4">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                                <span>Sus datos están protegidos y encriptados — @2026 CrediDigital</span>
                            </div>
                            <div className="flex items-center gap-5">
                                <span className="flex items-center gap-1">
                                    <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                    </svg>
                                    SSL Seguro
                                </span>
                                <span className="flex items-center gap-1">
                                    <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                        <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                                    </svg>
                                    Cumplimiento Normativo
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default NuevaSolicitudYupana;
